import { ReportFeatures } from '@hcs/types';

export const MONTHS_OF_SUPPLY_CHART_FEATURES = [
  ReportFeatures.DaysOnMarketChart,
];
